import { addDays } from '@selflevel/domain';

const LETRAS = ['D', 'L', 'M', 'X', 'J', 'V', 'S'] as const;
const NOMBRES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] as const;

/** Mediodía UTC: ningún huso convierte un mediodía en otro día. */
const diaDeLaSemana = (localDate: string): number => new Date(`${localDate}T12:00:00Z`).getUTCDay();

export function tiraDeDias(hasta: string, n: number): string[] {
  return Array.from({ length: n }, (_, i) => addDays(hasta, i - (n - 1)));
}

export function letraDelDia(localDate: string): string {
  return LETRAS[diaDeLaSemana(localDate)] ?? '';
}

export function nombreDelDia(localDate: string): string {
  return NOMBRES[diaDeLaSemana(localDate)] ?? '';
}

/** Lo que el lector de pantalla dice de un día: la fecha, si es hoy y si hay algo anotado. */
export function etiquetaDelDia(fecha: string, esHoy: boolean, marcado: boolean): string {
  return `${fecha}${esHoy ? ', hoy' : ''}${marcado ? ', con algo anotado' : ''}`;
}
